import { gettext } from '@eb/i18n';
import React from 'react';
import { createBreakpoint } from 'react-use';
import { OrganizerContext } from '../context';
import { DiscoveryEventsFromView, Organizer } from '../types';
import { FollowOrganizer } from './FollowOrganizer';
import './Main.scss';
import { OrganizerAbout } from './OrganizerAbout';
import { OrganizerEvents } from './OrganizerEvents';
import {
    TabNavigation,
    TabNavigationHeader,
    TabNavigationSection,
    TabNavLink,
    TabSection,
} from './TabNavigation';

interface MainProps {
    organizer: Organizer;
    events: DiscoveryEventsFromView;
}
const useBreakPoint = createBreakpoint({ desktop: 792, mobile: 0 });

const StickyHeaderContent: React.FunctionComponent = () => {
    const organizer = React.useContext(OrganizerContext) as Organizer;
    const [size, setSize] = React.useState('mini');
    const breakPoint = useBreakPoint(useBreakPoint);

    React.useEffect(() => {
        const dynamicSize = breakPoint === 'mobile' ? 'mini' : 'standard';
        setSize(dynamicSize);
    }, [breakPoint]);

    return (
        <div className="sticky-header__extra-content">
            <div className="sticky-header__organizer-name eds-text-bl">
                {organizer.name}
            </div>
            <FollowOrganizer organizer={organizer} size={size} />
        </div>
    );
};

export const Main: React.SFC<MainProps> = (props) => {
    return (
        <section className="main eds-g-cell eds-g-cell-12-12 eds-g-cell-lg-10-12 eds-g-offset-lg-1-12 eds-g-cell--has-overflow">
            <TabNavigation breakPoints={{ desktop: 792, mobile: 0 }}>
                <TabNavigationHeader
                    stickyNode={<StickyHeaderContent />}
                    stickyContentClassNames="organizer-profile__sticky-header--content eds-g-cell eds-g-cell-12-12 eds-g-cell-lg-10-12 eds-g-offset-lg-1-12 eds-g-cell--has-overflow"
                >
                    <TabNavLink
                        id="about"
                        containerClassName="eds-show-down-sw"
                        hide="desktop"
                    >
                        {gettext('About')}
                    </TabNavLink>
                    <TabNavLink id="events">{gettext('Events')}</TabNavLink>
                    {/* <TabNavLink id="collections">
                            {gettext('Collections')}
                        </TabNavLink> */}
                </TabNavigationHeader>
                <TabNavigationSection>
                    <TabSection
                        hide="desktop"
                        intersectionOptions={{
                            rootMargin: '-160px 0px 0px 0px',
                        }}
                    >
                        <OrganizerAbout type="mobile" />
                    </TabSection>
                    <TabSection
                        id="events"
                        containerClassName="organizer-profile__events-tab-section"
                    >
                        <OrganizerEvents events={props.events} />
                    </TabSection>
                    {/* <TabSection
                            id="collections"
                            containerClassName="organizer-profile__events-tab-section"
                        >
                            <div
                                style={{
                                    padding: '24px',
                                    backgroundColor: 'green',
                                    height: '700px',
                                    width: '100%',
                                }}
                            >
                                <h1>Collections</h1>
                            </div>
                        </TabSection> */}
                </TabNavigationSection>
            </TabNavigation>
        </section>
    );
};
